import { Chains } from '#/reduxState/exchange/exchangeActiveChainUtils';

export const getChainThemeSelector = (activeChain: Chains) => {
  return activeChain === 'katanaEVMChain'
    ? 'isKatanaChainTheme'
    : activeChain === 'polygonPoSChain' // activeChain === 'xchainEVMChain'
    ? 'isXChainTheme'
    : activeChain === 'binanceChain'
    ? 'isBinanceChainTheme'
    : 'isEthereumChainTheme';
};
